import React from 'react';
import { useLanguage } from './LanguageContext';

const TALEN = [
  { code: 'nl', label: 'NL', vlag: '🇳🇱' },
  { code: 'en', label: 'EN', vlag: '🇬🇧' },
  { code: 'de', label: 'DE', vlag: '🇩🇪' },
  { code: 'fr', label: 'FR', vlag: '🇫🇷' },
];

export default function TaalWisselaar({ stijl = 'sidebar' }) {
  const { taal, wisselTaal } = useLanguage();

  if (stijl === 'sidebar') {
    return (
      <div style={{
        display: 'flex', gap: 4, padding: '8px 10px',
        borderTop: '1px solid rgba(255,255,255,0.08)',
        flexWrap: 'wrap',
      }}>
        {TALEN.map(l => (
          <button
            key={l.code}
            onClick={() => wisselTaal(l.code)}
            title={l.vlag + ' ' + l.label}
            style={{
              flex: 1,
              padding: '4px 2px',
              background: taal === l.code ? 'rgba(212,168,72,0.25)' : 'transparent',
              border: taal === l.code ? '1px solid #d4a848' : '1px solid transparent',
              borderRadius: 4,
              color: taal === l.code ? '#d4a848' : 'rgba(255,255,255,0.5)',
              fontSize: 10,
              fontWeight: taal === l.code ? 700 : 400,
              cursor: 'pointer',
              letterSpacing: '.05em',
              transition: 'all .15s',
            }}
          >
            {l.vlag} {l.label}
          </button>
        ))}
      </div>
    );
  }

  // Login stijl — horizontaal
  return (
    <div style={{ display: 'flex', gap: 6, justifyContent: 'center' }}>
      {TALEN.map(l => (
        <button
          key={l.code}
          onClick={() => wisselTaal(l.code)}
          style={{
            padding: '4px 10px',
            background: taal === l.code ? '#1a364c' : 'transparent',
            border: '1px solid #1a364c',
            borderRadius: 20,
            color: taal === l.code ? 'white' : '#1a364c',
            fontSize: 12,
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          {l.vlag} {l.label}
        </button>
      ))}
    </div>
  );
}
